module.exports = __webpack_public_path__ + "img/logoc2i.393bfe82.png";